import { serializeErrorMessage } from 'src/utils';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import GalleryService from 'src/services/gallery.services';
import { DashboardItemList } from 'src/types/dashboard';
import DashboardServices from 'src/services/dashboard.services';
import AuthService from 'src/services/auth.service';
import { getUser } from 'src/features/user/user.slice';

interface DashboardState {
  serviceError?: string;
  serviceSuccessMessage?: string;
  isLoading: boolean;
  dashboardItems: [];
}

export const getDashboardItems = createAsyncThunk(
  'dashboard/get',
  async ({ }, thunkAPI) => {
    try {
      const res = await DashboardServices.getAll();
    } catch (error) {
      const message = serializeErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
)

export const masqueradeAsUser = createAsyncThunk(
  'dashboard/masqueradeAsUser',
  async (userId: string, { dispatch, rejectWithValue, getState }) => {
    try {
      // Store the current user info before masquerading
      const currentUser = (getState() as any).user.user;
      if (currentUser) {
        // Store original user data
        localStorage.setItem('original_user', JSON.stringify({
          id: currentUser.id || currentUser.uuid,
          name: `${currentUser.first_name} ${currentUser.last_name}`,
          isMasquerading: true
        }));

        // Store the admin's token
        const currentToken = localStorage.getItem('user');
        if (currentToken) {
          try {
            const userData = JSON.parse(currentToken);
            if (userData.access_token) {
              localStorage.setItem('original_admin_token', userData.access_token);
            }
          } catch (error) {
            console.error('Error storing admin token:', error);
          }
        }
      }

      // Use AuthService for masquerading to maintain consistency with the old implementation
      const response = await AuthService.masquerade(userId);

      if (response.access_token) {
        // Update the Redux state with the new user
        dispatch(getUser());
        // Add a small delay before redirecting to ensure token is saved
        setTimeout(() => {
          // Redirect to channels page
          window.location.href = '/channels';
        }, 500);
      } else {
        console.error('Masquerade response missing access_token:', response);
        throw new Error('No access token received from masquerade response');
      }

      return response;
    } catch (error: any) {
      console.error('Masquerade error:', error);
      const errorMessage = error.response?.data?.message ||
        error.message ||
        'Failed to masquerade as user';
      return rejectWithValue(errorMessage);
    }
  }
);